<section class="cmn-innerpage-wrapper invoice-new">
  <h2 class="cmn-inner-heading">
    {{ dailyExpenseId ? "Update Daily Purchase" : "Create Daily Purchase" }}
  </h2>
  <form [formGroup]="purchaseNewForm">
    <div class="invoice-new-form-wrapper">
      <div class="form-wrapper invoice-form-wrapper">
        <div class="cmn-Search-select-container">
          <label for="supplierName"
            >Choose Supplier<span class="red">*</span></label
          >
          <mat-form-field>
            <mat-select
              placeholder="Search Supplier"
              id="supplierName"
              formControlName="supplierName"
              (selectionChange)="onSupplierSearch($event)"
            >
              <mat-option>
                <ngx-mat-select-search
                  placeholderLabel="Search Supplier"
                  [formControl]="suplierSearchCntrl"
                  [noEntriesFoundLabel]="'No options found'"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let item of suppliersData" [value]="item.id">
                {{ item.supplierName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  purchaseNewForm.get('supplierName')!.touched &&
                  purchaseNewForm.get('supplierName')!.hasError('required')
                "
                >Supplier Name is required.</mat-error
              >
            </span>
          </div>
        </div>

        <div>
          <label for="billNumber">Bill No<span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              placeholder="Bill No"
              id="billNumber"
              maxlength="30"
              formControlName="billNumber"
            />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  purchaseNewForm.get('billNumber')!.touched &&
                  purchaseNewForm.get('billNumber')!.hasError('required')
                "
                >Bill No is required.</mat-error
              >
            </span>
            <!-- <span>
              <mat-error
                *ngIf="
                  purchaseNewForm.get('billNumber')!.touched &&
                  purchaseNewForm.get('billNumber')!.hasError('pattern')
                "
                >Please enter a valid billNumber (only numbers
                allowed).</mat-error
              >
            </span> -->
          </div>
        </div>

        <div>
          <label for="billDate">Date<span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="invoiceDatePicker"
              placeholder="Select Date"
              id="invoiceDate"
              formControlName="billDate"
              [max]="today"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="invoiceDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker #invoiceDatePicker></mat-datepicker>
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  purchaseNewForm.get('billDate')!.touched &&
                  purchaseNewForm.get('billDate')!.hasError('required')
                "
                >Date is required.</mat-error
              >
            </span>
          </div>
        </div>

        <div>
          <label for="paymentTerms"
            >Payment Method<span class="red">*</span></label
          >
          <mat-form-field>
            <mat-select
              placeholder="Payment Method"
              id="paymentMethod"
              formControlName="paymentMethod"
            >
              <mat-option *ngFor="let mode of paymentModeList" [value]="mode">
                {{ mode }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  purchaseNewForm.get('paymentMethod')!.touched &&
                  purchaseNewForm.get('paymentMethod')!.hasError('required')
                "
                >Payment Method is required.</mat-error
              >
            </span>
          </div>
        </div>

        <div *ngIf="purchaseNewForm.get('paymentMethod')?.value === 'Cheque'">
          <label for="chequeNo">Cheque Number<span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              placeholder="Cheque Number"
              id="chequeNo"
              formControlName="chequeNo"
            />
          </mat-form-field>
          <div class="custom-error">
            <mat-error
              *ngIf="
                purchaseNewForm.get('chequeNo')?.hasError('required') &&
                purchaseNewForm.get('chequeNo')?.touched
              "
            >
              Cheque Number is required.
            </mat-error>
          </div>
        </div>

        <div *ngIf="purchaseNewForm.get('paymentMethod')?.value === 'Cheque'">
          <label for="chequeDate">Cheque Date<span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              [matDatepicker]="picker"
              placeholder="Cheque Date"
              id="chequeDate"
              formControlName="chequeDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <div class="custom-error">
            <mat-error
              *ngIf="
                purchaseNewForm.get('chequeDate')?.hasError('required') &&
                purchaseNewForm.get('chequeDate')?.touched
              "
            >
              Cheque Date is required.
            </mat-error>
          </div>
        </div>
      </div>

      <div class="form-wrapper invoice-form-wrapper form-wrapper-secondary">
        <div class="cmn-Search-select-container">
          <label for="stationaryName"
            >Item Name<span class="red">*</span></label
          >
          <mat-form-field>
            <mat-select
              placeholder="Search Stationary Item"
              id="stationaryName"
              formControlName="stationaryName"
            >
              <mat-option>
                <ngx-mat-select-search
                  placeholderLabel="Search Stationary Item"
                  [formControl]="stationarySearchCntrl"
                  [noEntriesFoundLabel]="'No options found'"
                ></ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let item of stationaryData" [value]="item.id">
                {{ item.itemName }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  purchaseNewForm.get('stationaryName')!.touched &&
                  purchaseNewForm.get('stationaryName')!.hasError('required')
                "
                >Stationary Item Name is required.</mat-error
              >
            </span>
          </div>
        </div>

        <div>
          <label for="quantity">Quantity<span class="red">*</span></label>
          <mat-form-field>
            <input
              matInput
              placeholder="Quantity"
              id="quantity"
              maxlength="10"
              formControlName="quantity"
              (keypress)="allowOnlyInteger($event)"
              (paste)="blockInvalidPaste($event)"
            />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  purchaseNewForm.get('quantity')!.touched &&
                  purchaseNewForm.get('quantity')!.hasError('required')
                "
                >Bank Charges is required.</mat-error
              >
            </span>
            <span>
              <mat-error
                *ngIf="
                  purchaseNewForm.get('quantity')!.touched &&
                  purchaseNewForm.get('quantity')!.hasError('pattern')
                "
                >Please enter a valid quantity (only numbers
                allowed).</mat-error
              >
            </span>
          </div>
        </div>
        <div>
          <label for="unitPrice">Unit Price<span class="red">*</span></label>
          <mat-form-field>
            <!-- <input
              matInput
              placeholder="0.00"
              id="unitPrice"
              maxlength="10"
              formControlName="unitPrice"
              (keypress)="allowOnlyDecimal($event)"
            /> -->
            <input
              matInput
              placeholder="0.00"
              id="unitPrice"
              formControlName="unitPrice"
              [readonly]="true"
            />
          </mat-form-field>
          <div class="custom-error">
            <span>
              <mat-error
                *ngIf="
                  purchaseNewForm.get('unitPrice')!.touched &&
                  purchaseNewForm.get('unitPrice')!.hasError('required')
                "
                >Bank Charges is required.</mat-error
              >
            </span>
            <span>
              <mat-error
                *ngIf="
                  purchaseNewForm.get('unitPrice')!.touched &&
                  purchaseNewForm.get('unitPrice')!.hasError('pattern')
                "
                >Please enter a valid unit price (only numbers
                allowed).</mat-error
              >
            </span>
          </div>
        </div>
        <button class="add-items-btn" (click)="addItem()">
          <img
            src="../../../assets/images/icons/icon-add-color.svg"
            alt="Add"
          />
          Add items
        </button>
      </div>
    </div>

    <div class="item-service-adding-table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Item Name</th>
            <th>Unit Price</th>
            <th>Quantity</th>
            <th>Sub Total</th>
            <th>Tax (5%)</th>
            <th>Total</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of addedItems">
            <td>{{ item.itemName }}</td>
            <td>AED {{ item.unitPrice }}</td>
            <td>{{ item.quantity }}</td>
            <td>AED {{ item.subTotal | number : "1.2-2" }}</td>
            <td>AED {{ item.tax | number : "1.2-2" }}</td>
            <td>AED {{ item.total | number : "1.2-2" }}</td>
            <td>
              <button (click)="removeItem(item.id)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                >
                  <g opacity="0.7">
                    <path
                      d="M7.17188 3.45312V3.71875H9.82812V3.45312C9.82812 3.10088 9.6882 2.76307 9.43913 2.514C9.19005 2.26493 8.85224 2.125 8.5 2.125C8.14776 2.125 7.80995 2.26493 7.56087 2.514C7.3118 2.76307 7.17188 3.10088 7.17188 3.45312ZM6.10938 3.71875V3.45312C6.10938 2.81909 6.36124 2.21103 6.80957 1.7627C7.2579 1.31437 7.86597 1.0625 8.5 1.0625C9.13403 1.0625 9.7421 1.31437 10.1904 1.7627C10.6388 2.21103 10.8906 2.81909 10.8906 3.45312V3.71875H14.875C15.0159 3.71875 15.151 3.77472 15.2507 3.87435C15.3503 3.97398 15.4062 4.1091 15.4062 4.25C15.4062 4.3909 15.3503 4.52602 15.2507 4.62565C15.151 4.72528 15.0159 4.78125 14.875 4.78125H14.0739L13.0688 13.583C12.9946 14.2312 12.6845 14.8295 12.1976 15.2637C11.7106 15.698 11.0809 15.9378 10.4284 15.9375H6.57156C5.91911 15.9378 5.28937 15.698 4.80242 15.2637C4.31547 14.8295 4.00537 14.2312 3.93125 13.583L2.92612 4.78125H2.125C1.9841 4.78125 1.84898 4.72528 1.74935 4.62565C1.64972 4.52602 1.59375 4.3909 1.59375 4.25C1.59375 4.1091 1.64972 3.97398 1.74935 3.87435C1.84898 3.77472 1.9841 3.71875 2.125 3.71875H6.10938ZM4.98737 13.4619C5.03173 13.8507 5.21759 14.2096 5.50955 14.4702C5.80151 14.7308 6.17915 14.8749 6.5705 14.875H10.429C10.8203 14.8749 11.198 14.7308 11.4899 14.4702C11.7819 14.2096 11.9677 13.8507 12.0121 13.4619L13.005 4.78125H3.99553L4.98737 13.4619ZM6.90625 6.64062C7.04715 6.64062 7.18227 6.6966 7.2819 6.79622C7.38153 6.89585 7.4375 7.03098 7.4375 7.17188V12.4844C7.4375 12.6253 7.38153 12.7604 7.2819 12.86C7.18227 12.9597 7.04715 13.0156 6.90625 13.0156C6.76535 13.0156 6.63023 12.9597 6.5306 12.86C6.43097 12.7604 6.375 12.6253 6.375 12.4844V7.17188C6.375 7.03098 6.43097 6.89585 6.5306 6.79622C6.63023 6.6966 6.76535 6.64062 6.90625 6.64062ZM10.625 7.17188C10.625 7.03098 10.569 6.89585 10.4694 6.79622C10.3698 6.6966 10.2346 6.64062 10.0938 6.64062C9.95285 6.64062 9.81773 6.6966 9.7181 6.79622C9.61847 6.89585 9.5625 7.03098 9.5625 7.17188V12.4844C9.5625 12.6253 9.61847 12.7604 9.7181 12.86C9.81773 12.9597 9.95285 13.0156 10.0938 13.0156C10.2346 13.0156 10.3698 12.9597 10.4694 12.86C10.569 12.7604 10.625 12.6253 10.625 12.4844V7.17188Z"
                      fill="#AB0010"
                    />
                  </g>
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="total-amount-display" *ngIf="addedItems.length > 0">
        <p>Grand Total: AED {{ grandTotal.toFixed(2) }}</p>
      </div>
    </div>
    <div class="upload-file-group wrapper-top" *ngIf="!dailyExpenseId">
      <h2>Attach Bill</h2>
      <input
        #fileInput
        type="file"
        style="display: none"
        formControlName="fileUploadUrl"
        (change)="onFileSelected($event)"
        accept=".pdf"
      />

      <button type="button" class="cmn-upload-btn" (click)="fileInput.click()">
        <img src="assets/images/icons/icon-upload.svg" alt="Upload Icon" />
        <span>Upload File</span>
      </button>

      <div class="uploaded-file" *ngIf="pdfFile.length > 0">
        <div>
          <h6 (click)="onViewDocument(pdfFile[0])">
            {{ pdfFile[0].file.name }}
            <img
              (click)="removeFile()"
              src="assets/images/icons/icon-close.svg"
              alt="Close Icon"
            />
          </h6>
        </div>
      </div>
    </div>

    <div class="submit-btn-wrapper">
      <button class="cmn-cancel-btn" type="reset" (click)="onCancel()">
        Cancel
      </button>
      <button class="cmn-next-btn" type="button" (click)="onSubmit()">
        Submit
      </button>
    </div>
  </form>
</section>
